/* eslint-disable max-len */
import { Grid } from "@mui/material";
import Policies from "../termsofservice/component/Policies";
import styles from "../termsofservice/Policy.module.css";

const TERMS_SECTIONS = [
  {
    id: "eligibility",
    title: "Eligibility",
    body: [
      "The Teacher Reward System is available only to schools subscribed to the Shelf21 Pro Plan.",
      "Schools using the free plan are not eligible to access or participate in the reward system unless upgraded to an active Pro subscription."
    ]
  },
  {
    id: "reward-point-allocation",
    title: "Reward Point Allocation",
    body: [
      "Teachers may earn points through selected activities and features available within the Shelf21 platform.",
      "Point allocation is determined solely by Shelf21 and may vary based on activity type, feature usage, participation level, system updates, and promotional campaigns."
    ]
  },
  {
    id: "feature-eligibility-and-point-changes",
    title: "Feature Eligibility & Point Changes",
    body: [
      "Shelf21 reserves the full right to decide which activities earn points, modify the number of points assigned to any activity, and remove point eligibility from any feature at any time.",
      "Attendance marking may earn points today and may stop earning points in the future. New activities may be added or removed without prior notice."
    ]
  },
  {
    id: "reward-conversion-and-withdrawal-value",
    title: "Reward Conversion & Withdrawal Value",
    body: [
      "Points do not have a fixed monetary value.",
      "The withdrawal or conversion value of points is determined based on the active point rate at the time of withdrawal or redemption.",
      "The value of points may increase or decrease over time, and previously earned points may be converted at the current active rate during withdrawal.",
      "Shelf21 reserves the right to adjust point conversion rates at any time."
    ]
  },
  {
    id: "fraudulent-activities-and-suspicious-behavior",
    title: "Fraudulent Activities & Suspicious Behavior",
    body: [
      "Shelf21 reserves the right to investigate, suspend, delay, reject, or hold any withdrawal request suspected to involve fraudulent activity, artificial point generation, abuse of the system, fake academic activities, manipulation of platform features, unauthorized access, or misuse.",
      "Any user or school found engaging in fraudulent behavior may lose accumulated points, have rewards canceled, or be suspended from the reward system."
    ]
  },
  {
    id: "no-guaranteed-earnings",
    title: "No Guaranteed Earnings",
    body: [
      "Participation in the Teacher Reward System does not guarantee fixed income, salary increases, or specific reward amounts.",
      "Rewards are based on eligible activities completed, points accumulated, active conversion rates, school participation status, and reward policies active at the time."
    ]
  },
  {
    id: "final-decision-rights",
    title: "Final Decision Rights",
    body: [
      "All decisions regarding point allocation, reward eligibility, withdrawals, fraud investigations, conversion rates, and account participation remain solely at the discretion of Shelf21."
    ]
  },
  {
    id: "acceptance-of-terms",
    title: "Acceptance of Terms",
    body: [
      "By participating in the Teacher Reward System, schools, administrators, and teachers acknowledge that they have read, understood, and agreed to these Terms & Conditions."
    ]
  }
];

const TeacherRewardTermsPage = () => {
  return (
    <div className={styles.containerbcg}>
      <div className={`${styles.container} termsofservice`}>
        <div className={styles.contmargin}>
          <Policies
            policyTitle="Teacher Reward System Terms & Conditions"
            policySubTitle="These Terms & Conditions govern the use of the Shelf21 Teacher Reward System."
          />

          <div className={styles.policymaincont}>
            <Grid container gap="24px">
              <Grid item className={styles.itemleft} lg={3} md={3} sm={12} xs={12}>
                {TERMS_SECTIONS.map((section, index) => (
                  <div key={section.id} className="flex gap-8">
                    <p>{index + 1}.</p>
                    <a href={`#${section.id}`}>{section.title}</a>
                  </div>
                ))}
              </Grid>

              <Grid item className={styles.itemright} lg={8.75} md={8.75} sm={12} xs={12}>
                <h4>Teacher Reward System Terms &amp; Conditions</h4>
                <p className={`${styles.policycontent} margin-top-20`}>
                  These Terms &amp; Conditions govern the use of the Shelf21 Teacher Reward System. By participating in the reward program, users agree to the terms stated below.
                </p>

                {TERMS_SECTIONS.map((section, index) => (
                  <div key={section.id}>
                    <h5 id={section.id}>
                      {index + 1}. {section.title}
                    </h5>
                    {section.body.map((paragraph) => (
                      <p key={paragraph} className={`${styles.policycontent} margin-top-20`}>
                        {paragraph}
                      </p>
                    ))}
                  </div>
                ))}
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherRewardTermsPage;
